export enum ExpenseTypeEnum {
    MATERIAL = "Material Expense",
    CORPORATE = "Corporate Tax",
    ELECTRICITY = "Electricity Expense",
    MAINTENANCE = "Maintenance Expense",
    MISCELLANEOUS = "Miscellaneous Expense",
    RENT = "Rent Expense"
}